<template>
<div>
  <div class="duan" v-for="(val, key, i) in atlasList" :key="i">
    <div class="tile">
      <img src="@/assets/atlas/xbai2x.png" class="img" style="vertical-align:middle"/>
      <span style="vertical-align:middle">{{key}}</span>
    </div>
    <div class="index-atlas-default" >
      <div
        class="index-atlas-item"
        @click="addw(item)"
        v-for="(item, index) in val" :key="index"
      > 
        <img :src="item.type=='1'?imgw:item.picUrl" alt class="index-atlas-img" />
        <div class="div" v-show="item.type=='1'">
          <p class="p1 van-ellipsis">{{item.atlasCategoryName}}</p>
          <p class="p2">（{{item.atlasCount}}）</p>
        </div>
        <p class="p3" v-show="item.type=='2'">￥{{item.price}}</p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {
      img: require("@/assets/atlas/2.png"),
      imgw: require("@/assets/atlas/d.png"),
      userInfo:{}
    };
  },
  methods: {
    addw(item) {
      if (item.type == "1") {
        if (item.atlasCount != 0) {
          this.$emit("navClick", item);
        } else {
          this.$toast("该目录下没有内容");
        }
      } else {
        gio('track','userImageProductEnterDetails_var',{
          foundID_var: item.discoverId+'',
          userID_var: this.userInfo.userId+'',
          userName_var: this.userInfo.nickName,
          beeID_var: this.$route.query.beesId+'',
          beeName_var: item.beesName
          })
        if (this.$route.query.brandId) {
          let sharetype=this.$route.query.sharetype || "";
          let url=`${window.location.origin}/h5user/atlasProductDetail?batchNo=${encodeURI(item.batchNo)}&atlasId=${item.atlasId}&discoverId=${item.discoverId}&goodsId=${item.goodsId}&type=user&sharetype=${sharetype}`;
          utils.jumpToNewPage({
            url: url,
            noTitle: '0'
          });
        } else {
          this.$router.push({
            path: "/atlasProductDetail",
            query: {
              atlasId: item.atlasId,
              discoverId: item.discoverId,
              goodsId: item.goodsId,
              sharetype: this.$route.query.sharetype || "",
              type: "user"
            }
          });
        }
      }
    }
  },
  props: {
    atlasList: {
      defualt: function() {
        return {};
      },
      type: Object
    }
  },
  created(){
    //console.log(this.atlasList)
    if(localStorage.getItem('userInfo')){
     this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    };
    
  }
};
</script>
<style lang="less" scoped>
.duan{
  margin-bottom: 10px;
  background-color: #F7F7F7;
}
.tile{
  padding-left: 30px;
  font-size:26px;
  font-weight: bold;
  color: #333333;
  background-color: #ffffff;
  padding-top: 24px;
  padding-bottom: 26px;
  clear: both;
  .img{
    width: 30px;
    height: 30px;
  }
}
.index-atlas-default {
  padding: 20px 31.5px;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .index-atlas-item {
    position: relative;
    width: 155px;
    height: 155px;
    font-size: 20px;
    color: #333;
    margin: 8px;
    .index-atlas-img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .div {
      position: absolute;
      top: 60px;
      text-align: center;
      width: 100%;
      .p1 {
        padding: 0 5px;
      }
    }
    .p3 {
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      text-align: center;
      position: absolute;
      width: 100%;
      bottom: 0;
    }
  }
}
</style>